module.exports = __webpack_public_path__ + "img/card_13.2ae0f187.png";